/* eslint-disable no-unused-vars */

export class UserModel {
    constructor(
        public email: string,
        public picture: string
    ) {}
}
